import { useEffect } from "react";
import { useSetState } from "react-use";
import { PodDetailsType } from "../types";
import { getPodDetails } from "../utils/pod-details";

export function usePodDetails(
  podKeyOrSerialNumber: string
): [PodDetailsType, boolean, Error] {
  const [state, setState] = useSetState<{
    podDetails: PodDetailsType;
    isLoading: boolean;
    error: Error;
  }>({ podDetails: null, isLoading: true, error: null });

  useEffect(() => {
    async function loadPodDetails(id: string) {
      setState({ isLoading: true });
      try {
        const details = await getPodDetails(id);
        setState({ podDetails: details, isLoading: false, error: null });
      } catch (e) {
        setState({ podDetails: null, isLoading: false, error: e });
      }
    }

    if (podKeyOrSerialNumber) {
      loadPodDetails(podKeyOrSerialNumber);
    }
  }, [podKeyOrSerialNumber]);

  return [state.podDetails, state.isLoading, state.error];
}
